import React, { PureComponent } from 'react'
import { bool } from 'prop-types'
import styled from 'styled-components'
import axios from 'axios'

import MEDIA from 'styles/media'
import user from './images/user.svg'

const Wrapper = styled.div`
  display: flex;

  ${MEDIA.mobile} {
    margin-bottom: 36px;
  }
`

const Avatar = styled.div`
  width: 38px;
  height: 38px;
  background: url(${({ backgroundImg }) => backgroundImg}) no-repeat
    center;
  background-size: ${({ hasAvatar }) =>
    hasAvatar ? 'cover' : '24px'};
  border-radius: 50%;
  box-shadow: 0 1px 10px 0 rgba(107, 107, 107, 0.5);

  ${MEDIA.mobile} {
    width: 68px;
    height: 68px;
    margin-right: 75px;
  }
`

class Tools extends PureComponent {
  state = {
    url: undefined
  }

  componentDidMount() {
    if (this.props.isStory) {
      return
    }

    axios
      .get(`${process.env.REACT_APP_API_URL}/profile-pic`, {
        responseType: 'arraybuffer',
        withCredentials: true
      })
      .then(({ data }) => {
        const url = window.URL.createObjectURL(new Blob([data]))
        return this.setState({ url })
      })
      .catch(async error => {
        console.log(error)
      })
  }

  render() {
    const { url } = this.state
    return (
      <Wrapper>
        <Avatar
          backgroundImg={url || user}
          hasAvatar={Boolean(url)}
          alt='Avatar'
        />
      </Wrapper>
    )
  }
}

Tools.propTypes = {
  isStory: bool
}

Tools.defaultProps = {
  isStory: false
}

export default Tools



// WEBPACK FOOTER //
// ./src/layouts/DefaultLayout/components/NavBar/components/Tools/index.js